
/****************************************************************************
*
* PAGINATION
*
*****************************************************************************/
var Pagination = new Object();

Pagination.updateRowsPerPage = function(rowsPerPage,strPaginationAction) {
  Util.doAction(strPaginationAction,false,strFormName);
}

Pagination.goToPage = function(pageStartRow,strPaginationAction,strFormName,strPrefix) {
	if (strFormName === undefined) {
		strFormName = 'frmMain';
	}
    document.forms[strFormName].PAGINATION_SET_PAGE.value='true';
    document.forms[strFormName][strPrefix + '_pageStartRow'].value=pageStartRow;
    Util.doAction(strPaginationAction,false,strFormName);
}

Pagination.sortTable = function(sortBy,strPaginationAction,strFormName,strPrefix) {
	if (strFormName === undefined) {
		strFormName = 'frmMain';
	}
	if (strPrefix === undefined) {
		strPrefix = 'pagination';
	}
    document.forms[strFormName].pagination_sortBy.value=sortBy;
    document.forms[strFormName][strPrefix+'_ascending'].value=(document.forms[strFormName][strPrefix+'_ascending'].value == 'true' ? 'false' : 'true');
    Util.doAction(strPaginationAction,false,strFormName);
}

Pagination.paramsToString = function(strFormName,strPrefix) {
	if (strFormName === undefined) {
		strFormName = 'frmMain';
	}
	if (strPrefix === undefined) {
		strPrefix = 'pagination';
	}
	var strParams = strPrefix+'_sortBy=' + document.forms[strFormName][strPrefix + '_sortBy'].value +
		'&' + strPrefix + '_ascending=' + document.forms[strFormName][strPrefix + '_ascending'].value +  
		'&' + strPrefix + '_pageStartRow=' + document.forms[strFormName][strPrefix + '_pageStartRow'].value;
	return strParams;  
}
